const intervalId = setInterval(() => {
  const widget = document.querySelector('.product-information_section-inner .rebuy-bundle');
  if (widget) {  

  // ======================== START :  Heading and div append Js ================================

    const imagesContainer = document.querySelector('.rebuy-bundle__images');
    const actionsDiv = document.querySelector('.rebuy-bundle__actions');

    if (imagesContainer && actionsDiv) {
      imagesContainer.appendChild(actionsDiv);
    }

    if (actionsDiv) {
      // Create new heading div
      const headingDiv = document.createElement('div');
      headingDiv.classList.add('rebuy-bundle-heading');

      const originalHeading = document.querySelector('.product-information_section-inner h1');
      headingDiv.textContent = originalHeading ? originalHeading.textContent : "Default Heading";

      // Append headingDiv inside actionsDiv
      actionsDiv.appendChild(headingDiv);
    }

  // ======================== END :  Heading and div append Js ================================


  // ======================== START :  Save Price Js ================================

    // Dynamic price save calculation & insertion
    const priceValue = document.querySelector('.rebuy-bundle__actions-price-value');
    if (priceValue && !priceValue.querySelector('.rebuy-money.save-price')) {
      const saleSpan = priceValue.querySelector('.rebuy-money.sale span:not(.sr-only)');
      const originalSpan = priceValue.querySelector('.rebuy-money.compare-at span:not(.sr-only)');

      if (saleSpan && originalSpan) {
        const saleText = saleSpan.textContent.trim();
        const originalText = originalSpan.textContent.trim();

        const currency = saleText[0];
        const salePrice = parseFloat(saleText.slice(1).replace(/,/g, ''));
        const originalPrice = parseFloat(originalText.slice(1).replace(/,/g, ''));

        if (!isNaN(salePrice) && !isNaN(originalPrice) && originalPrice > salePrice) {
          const saveAmount = (originalPrice - salePrice).toFixed(2);

          const saveSpan = document.createElement('span');
          saveSpan.classList.add('rebuy-money', 'save-price');
          saveSpan.textContent = `save: ${currency}${saveAmount}`;

          priceValue.appendChild(saveSpan);
        }
      }
    }

    // ======================== END :  Save Price Js ================================

    // ======================== START :  Drop Down  Js ================================

    const firstItem = document.querySelector('.rebuy-bundle__items');
    if (firstItem) {
      const newDiv = document.createElement('div');
      newDiv.classList.add('rebuy-include-dropdown');

      const textNode = document.createTextNode("What’s included: ");
      newDiv.appendChild(textNode);

      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("width", "17");
      svg.setAttribute("height", "17");
      svg.setAttribute("viewBox", "0 0 17 17");
      svg.setAttribute("fill", "none");
      svg.classList.add('rebuy-icon');

      const path = document.createElementNS(svgNS, "path");
      path.setAttribute("d", "M8.01995 8.01909L11.3198 11.3189L12.2626 10.3761L8.01995 6.13343L3.77734 10.3761L4.72015 11.3189L8.01995 8.01909Z");
      path.setAttribute("fill", "black");

      svg.appendChild(path);
      newDiv.appendChild(svg);

      firstItem.classList.add('active');

      newDiv.addEventListener('click', () => {
        firstItem.classList.toggle('active');
      });

      firstItem.prepend(newDiv);
    }

    // ======================== END :  Drop Down  Js ================================


    // ======================== START :Radio Butto Js ================================
    var addBtn = document.querySelector(".custom-product-add-btn");
    var formAddButton = document.querySelector(".product-form-submit-button #add-to-cart");
    const bundle = document.querySelector('.rebuy-bundle');
    // Skip if checkbox already exists
    if (bundle.querySelector('input.rebuy-bundle-radio')) return;

    // Create bundle checkbox
    const bundleCheckbox = document.createElement('input');
    bundleCheckbox.type = 'checkbox';
    bundleCheckbox.name = 'rebuy-bundle-selection';
    bundleCheckbox.classList.add('rebuy-bundle-radio');
    bundleCheckbox.value = `bundle-0`;
    bundleCheckbox.checked = true; // default checked

    // Insert checkbox at the start of the bundle
    bundle.prepend(bundleCheckbox);

    // Select all internal product checkboxes
    const productCheckboxes = bundle.querySelectorAll(
      '.rebuy-product-block .rebuy-product-checkbox .rebuy-checkbox-label input[type="checkbox"]'
    );

    // On page load, make all internal checkboxes checked
    productCheckboxes.forEach((cb) => (cb.checked = true));

    // Show/hide ATC buttons based on bundle checkbox on page load
    

    function toggleButtons(isBundleChecked) {
        if (!addBtn || !formAddButton) return;
        addBtn.style.display = isBundleChecked ? 'inline-flex' : 'none';
        formAddButton.style.display = isBundleChecked ? 'none' : 'inline-flex';
    }
    toggleButtons(bundleCheckbox.checked);
    // if (bundleCheckbox.checked) {
    //     addBtn.style.display = 'inline-flex';
    //     formAddButton.style.display = 'none';
    // } else {
    //     addBtn.style.display = 'none';
    //     formAddButton.style.display = 'inline-flex';
    // }

    // Toggle internal checkboxes when bundle checkbox is clicked
    bundleCheckbox.addEventListener('change', () => {
        const checked = bundleCheckbox.checked;
        productCheckboxes.forEach((cb) => {
          cb.checked = checked; // check all if bundle is checked, uncheck all if not
        });
        // Show/hide buttons
        toggleButtons(bundleCheckbox.checked);
        // if (checked) {
        //   addBtn.style.display = 'inline-flex';
        //   formAddButton.style.display = 'none';
        // } else {
        //   addBtn.style.display = 'none';
        //   formAddButton.style.display = 'inline-flex';
        // }
    });

  // ======================== END :Radio Butto Js ================================

    // ======================== START :Add to cart button Js ================================
    var rebuyWidget = document.querySelector(".product-information_section-inner .rebuy-widget");

    if (rebuyWidget && addBtn) {
      var priceEl = document.querySelector('.rebuy-bundle__actions-price-value .rebuy-money.sale span:nth-child(2)');
      var targetEl = document.querySelector('.custom-product-add-btn .rebuy-bundle-total-price');

      if (priceEl && targetEl) {
          var priceText = priceEl.textContent.trim(); 
          targetEl.textContent = `(${priceText})`; 
      }
      // Attach click event
      addBtn.addEventListener('click', function(e) {
          e.preventDefault(); // Prevent default if needed
          var hiddenBtn = document.querySelector(".rebuy-bundle__actions-buttons .rebuy-button");
          if (hiddenBtn) {
              hiddenBtn.click(); // Trigger hidden button
          }
      });
    }
    // ======================== END :Add to cart button Js ================================

    clearInterval(intervalId);
  }
}, 1000);

// ========== START: Bundle builder page ======================/
document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector(".template-bundle-builder-page")){
        var interval = setInterval(function () {
            var ctaContainer = document.querySelector(".rebuy-bundle-builder__cta-container");
            var guaranteeSection = document.querySelector(".shipping-guarantee-section");

            if (ctaContainer && guaranteeSection) {
            ctaContainer.appendChild(guaranteeSection);
            clearInterval(interval);
            }
        }, 100);
    }
});
// ========== END: Bundle builder page ======================/
/*** BEGIN: Deliver and Assemble ***/
(function() {
const postcodesUrl = '//myomaster.com/cdn/shop/t/63/assets/excluded-build-post-codes.json?v=28302158384697379271775140788';

class DeliverAndAssemble extends HTMLElement {
  static mounted;

  constructor() {
    super();

    fetch(postcodesUrl)
        .then(resp => resp.json())
        .then(data => this.postcodes = data.codes);

  }

  // addMissingBuildProducts() {
  //   const items = Rebuy.Cart.getItems();
  //   const itemMap = new Map(items.map(item => [item.product_id, item]));
  //   const validMainIds = new Set(items.map(item => item.product_id));

  //   for (const { product_id, build_product_id, build_product_variant } of DeliverAndAssembleCombinations) {
  //       if (validMainIds.has(product_id) && !itemMap.has(build_product_id)) {
  //           Rebuy.Cart.addItem({id: build_product_variant, quantity: 1});
  //       }
  //   }
  // }
  addMissingBuildProducts() {
    const items = Rebuy.Cart.getItems();
    const itemMap = new Map(items.map(item => [item.product_id, item]));
    const validMainIds = new Set(items.map(item => item.product_id));

    for (const { product_id, build_product_id, build_product_variant } of DeliverAndAssembleCombinations) {
      if (validMainIds.has(product_id) && !itemMap.has(build_product_id)) {
        // ✅ Add a guard so the product is not added twice while Rebuy updates
        if (!this._addingBuildProduct) {
          this._addingBuildProduct = true;
          Rebuy.Cart.addItem({ id: build_product_variant, quantity: 1 }).then(() => {
            this._addingBuildProduct = false;
          });
        }
      }
    }
  }
  // addMissingBuildProducts() {
  //   const excludedBuildProducts = [55985881612665, 56190945132921]; // 🚫 excluded

  //   const items = Rebuy.Cart.getItems();
  //   const itemMap = new Map(items.map(item => [item.product_id, item]));
  //   const validMainIds = new Set(items.map(item => item.product_id));

  //   for (const { product_id, build_product_id, build_product_variant } of DeliverAndAssembleCombinations) {
  //     if (excludedBuildProducts.includes(build_product_id)) continue; // skip excluded

  //     if (validMainIds.has(product_id) && !itemMap.has(build_product_id)) {
  //       if (!this._addingBuildProduct) {
  //         this._addingBuildProduct = true;
  //         Rebuy.Cart.addItem({ id: build_product_variant, quantity: 1 }).then(() => {
  //           this._addingBuildProduct = false;
  //         });
  //       }
  //     }
  //   }
  // }

  removeBuildProductsWithMissingMainProduct() {
    const items = Rebuy.Cart.getItems();
    const validMainIds = new Set(items.map(item => item.product_id));
    const validMainIdsArr = [...validMainIds];

    //const comboMap = new Map(DeliverAndAssembleCombinations.map(c => [c.build_product_id, c.product_id]));
    const comboMap2 = new Map();

    DeliverAndAssembleCombinations.forEach(c => {
      let ids = [];
      if (comboMap2.has(c.build_product_id)) {
        ids = comboMap2.get(c.build_product_id);
      }

      ids.push(c.product_id);
      comboMap2.set(c.build_product_id, ids);
    });


    for (const item of [...items]) {
        const mainIds = comboMap2.get(item.product_id);

        if (mainIds && !mainIds.some(id => validMainIds.has(id))) {
            Rebuy.Cart.removeItem(item);
        }
    }
  }
  removeAllBuildProducts() {
    const items = Rebuy.Cart.getItems();
    const buildProductsIds = new Set(DeliverAndAssembleCombinations.map(c => c.build_product_id));

    for (const item of [...items]) {
        if (buildProductsIds.has(item.product_id)) 
            Rebuy.Cart.removeItem(item);
    }

    // ✅ Reset add flag so user can add again after removing
    this._addingBuildProduct = false;
  }

  // removeAllBuildProducts() {
  //   const excludedBuildProducts = [55985881612665, 56190945132921]; // 🚫 excluded

  //   const items = Rebuy.Cart.getItems();
  //   const buildProductsIds = new Set(
  //     DeliverAndAssembleCombinations
  //       .map(c => c.build_product_id)
  //       .filter(id => !excludedBuildProducts.includes(id)) // skip excluded
  //   );

  //   for (const item of [...items]) {
  //     if (buildProductsIds.has(item.product_id)) {
  //       Rebuy.Cart.removeItem(item);
  //     }
  //   }

  //   this._addingBuildProduct = false;
  // }


  makeSureBuildProductIsOne() {
    const items = Rebuy.Cart.getItems();
    const buildProductsIds = new Set(DeliverAndAssembleCombinations.map(c => c.build_product_id));
    
    for (const item of [...items]) {
        if (item.quantity > 1 && buildProductsIds.has(item.product_id)) 
            Rebuy.Cart.setItemQuantity(item, 1);
    }
  }

  checkPostCode() {
    const postcode = this.querySelector('input[id="postcode"]')?.value;
    const normalized = postcode.trim().toUpperCase();
    
    if (!/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s?(\d[A-Z]{2})$/.test(normalized)) {
      this.querySelector('.da-checker-result').dataset.result = 'regex';
      
      this.querySelectorAll('.da-inputs input').forEach(input => {
        input.setAttribute('disabled', true);
        if (input.value == 'no') {
          input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
        }
      });
      return;
    }
    if (!!this.postcodes.some(prefix => normalized.startsWith(prefix))) {
      this.querySelector('.da-checker-result').dataset.result = 'false';
      this.querySelector('.da-checker-result .da-result.da-eligible-false span').innerText = postcode;

      this.querySelectorAll('.da-inputs input').forEach(input => {
        input.setAttribute('disabled', true);
        if (input.value == 'no') {
          input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
        }
      });

      return;
    }

    this.querySelector('.da-checker-result').dataset.result = 'true';
    this.querySelectorAll('.da-inputs input').forEach(input => {
      input.disabled = false;
      if (input.value == 'yes') {
        input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
      }
    })
  }

  connectedCallback() {

    window.requestAnimationFrame(() => {
      
        const state = localStorage.getItem('deliver-and-assemble-state');
        if (state) {
            this.querySelector(`input[value="${state}"]`).checked = true;
        }

        if (this.classList.contains('da-cart')) {
          this.querySelector('.da-title-cart').addEventListener('click', () => {
            this.classList.toggle('da-expanded');
          });
        }
        const button = this.querySelector('.da-checker-inputs button');
        if (button) {
          button.addEventListener('click', () => {
            this.checkPostCode();
          });
        }

        this.querySelectorAll('input[type="radio"]').forEach(input => {
            input.addEventListener('change', (e) => {
                
                if (e.target.value == 'yes') {
                    this.addMissingBuildProducts();
                }
                if (e.target.value == 'no') {
                    this.removeAllBuildProducts();
                }

                localStorage.setItem('deliver-and-assemble-state', e.target.value);

                document.dispatchEvent(new CustomEvent('deliver-and-assemble:change', {
                    detail: {
                        value: e.target.value
                    }
                }));
            });
        })
    });

    document.addEventListener('deliver-and-assemble:change', (e) => {
        this.querySelector(`input[type="radio"][value="${e.detail.value}"]`).checked = true;
    });

    if (DeliverAndAssemble.mounted) return;

    DeliverAndAssemble.mounted = true;
    document.addEventListener('rebuy:cart.change', () => {
        
        this.removeBuildProductsWithMissingMainProduct();

        const checked = this.querySelector('input[value="yes"]:checked')?.value == 'yes';
        console.log('checked', checked);
        if (!checked) return;
        this.makeSureBuildProductIsOne();
        // this.addMissingBuildProducts();
        if (!this._addingBuildProduct) {
          this.addMissingBuildProducts();
        }
    });
  }

  disconnectedCallback() {

  }
}

customElements.define("deliver-and-assemble", DeliverAndAssemble);
})();
/*** END: Deliver and Assemble ***/



// ============== Stat :  Discount dropdwan function ==============

document.addEventListener("click", function(e) {
  const trigger = e.target.closest(".rebuy-have-discount-code");
  if (!trigger) return;

  const container = document.querySelector(".rebuy-cart__discount-container");
  if (!container) return;

  trigger.classList.toggle("showDiscount");
  container.classList.toggle("showDiscount");
});

// ============== End :  Discount dropdwan function ==============



// ============== Stat :  Dilivery date function ==============

window.deliveryProducts = `MyoPro
MyoIce Elite
MyoFreeze
MyoFreeze & MyoChill
MyoIce Elite & MyoChill
MyoZone
MyoChill
MyoChill+
MyoChill Filter
MyoChill+ Filter
MyoSauna Infrared
MyoSauna Lux
MyoSauna Classic
MyoAir 2.0
MyoIce Pro
MyoLite`.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
window.deliveryMessages = `DPD next working day delivery (order before 4pm)
DPD next working day delivery (order before 4pm)
DPD next working day delivery (order before 4pm)
Order by 4pm for next work day delivery
Order by 4pm for next work day delivery
Royal Mail 48 hour delivery 
DPD next working day delivery (order before 4pm)
Delivery within 21 days
Royal Mail 48 hour delivery 
Royal Mail 48 hour delivery 
In stock <br> Delivery within 7-14 days
In Stock <br> Schedule delivery within 48 hours. <br> Est delivery within 14 days.
Schedule delivery within 48 hours. Est delivery within 14 days.
DPD next working day delivery (order before 4pm)
DPD next working day delivery (order before 4pm)
DPD next working day delivery (order before 4pm)`.split(/\r?\n/).map(s => s.trim()).filter(Boolean);

(function(){

  function buildRules(){
    const rules = {};

    if (!window.deliveryProducts || !window.deliveryMessages) return rules;

    window.deliveryProducts.forEach((product, i) => {
      const name = product.trim().toLowerCase();
      const msg = window.deliveryMessages[i]?.trim();
      if (name && msg) {
        rules[name] = msg;
      }
    });

    return rules;
  }


  function updateCartDeliveryMessages() {
    const cartList = document.querySelector('ul[data-smartcart-items]');
    if (!cartList) return;

    const items = cartList.querySelectorAll('li');
    const deliveryRules = buildRules();

    items.forEach(item => {

      const titleEl = item.querySelector('.rebuy-cart__flyout-item-product-title');
      if (!titleEl) return;

      const productTitle = titleEl.textContent.trim().toLowerCase();

      // remove old message if exists
      const existingMsg = item.querySelector('.custom-delivery-message');
      if (existingMsg) existingMsg.remove();

      // if no rule → skip
      if (!deliveryRules[productTitle]) return;

      // create message
      const messageEl = document.createElement('div');
      messageEl.className = 'custom-delivery-message';
      messageEl.textContent = deliveryRules[productTitle];

      const priceContainer = item.querySelector('.rebuy-cart__flyout-item-price');
      if (priceContainer) {
        priceContainer.appendChild(messageEl);
      }

    });
  }


  /* ---------- EVENTS ---------- */

  document.addEventListener('rebuy:cart.ready', updateCartDeliveryMessages);

  document.addEventListener('rebuy:cart.show', updateCartDeliveryMessages);

  document.addEventListener('rebuy:cart.add', () => {
    setTimeout(updateCartDeliveryMessages, 500);
  });

  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(updateCartDeliveryMessages, 500);
  });

})();


// ============== End :  Dilivery date function ==============